import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { AdminModule, AdminModuleGroup } from "../../interfaces/interfaces";
import { ApiService } from '../../services/api.service';
import { DataService } from "../../services/data.service";

@Component({
    selector: 'app-modules',
    templateUrl: './modules.component.html',
    styleUrls: ['./modules.component.scss']
})
export class ModulesComponent extends UnsubscribeComponent {

    cdnBaseUrl: string = null;

    constructor(
        private router: Router,
        private apiService: ApiService,
        private dataService: DataService
    ) {
        super();
        this.cdnBaseUrl = this.dataService.cdnBaseUrl;
        this.getModules();
    }

    moduleGroups: AdminModuleGroup[] = [];

    selectModule(id: number): void {
        this.router.navigateByUrl('/modules/' + id);
    }

    getModules(): void {
        this.apiService.getModules().pipe(takeUntil(this.unsubscribe)).subscribe(({moduleGroups}) => {
            this.moduleGroups = moduleGroups;
        });
    }

}